// Libraries
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';

// Local
import Hero from './Components/Hero';
import SemanticSearchFeature from './Components/SemanticSearchFeature';
import SemanticReadFeature from './Components/SemanticReadFeature';

const Homepage = ({ title, session }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = title;

    if (session && session.status === 'success') {
      navigate('/notes');
    }
  }, []);

  return (
    <Stack
      direction="column"
      spacing={8}
      maxWidth={2700}
      sx={{
        width: '70%',
        marginTop: '1%',
        marginBottom: '5%',
        
        flexWrap: 'auto',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Hero />
      <SemanticSearchFeature />
      <SemanticReadFeature />
    </Stack>
  );
};

export default Homepage;
